import {
  AMAP_UI_SCRIPT_URL,
  AMAP_MAIN_SCRIPT_URL,
} from "../../common/constant";

// 生成 script 标签
function buildScriptTag(src: string) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.defer = true;
  script.src = src;
  return script;
}

/**
 * 加载高德 sdk
 * @returns Promise
 */
export function loadMain() {
  if (window.AMap) {
    return Promise.resolve();
  }
  //   // @ts-ignore
  //   window._AMapSecurityConfig = {
  //     securityJsCode: "4eaf7aadbd2e41fe33a26c0cfe76e426",
  //   };
  const serviceHost =
    "" + window.location.protocol + "//" + window.location.host + "/";
  // @ts-ignore
  window._AMapSecurityConfig = {
    serviceHost: serviceHost + "_AMapService",
    // 例如 ：serviceHost:'http://1.1.1.1:80/_AMapService',
  };
  console.log(serviceHost, "serviceHost");
  const script = buildScriptTag(AMAP_MAIN_SCRIPT_URL);
  const p = new Promise((resolve) => {
    // setup callback func
    window["__amap_init_callback"] = () => {
      resolve(true);
      delete window["__amap_init_callback"];
    };
  });
  document.body.appendChild(script);
  return p;
}

/**
 * 加载高德 ui
 * @returns Promise
 */
export function loadMapui() {
  if (window.AMapUI) {
    return Promise.resolve();
  }
  const script = buildScriptTag(AMAP_UI_SCRIPT_URL);
  const p = new Promise((resolve) => {
    script.onload = () => {
      if (window.initAMapUI) {
        window.initAMapUI();
      }
      resolve(true);
    };
  });
  document.body.appendChild(script);
  return p;
}
